module.exports = __webpack_public_path__ + "47c70d31371646e7e1823e56d769c283.svg";